import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SearchBox from "../../Components/SearchBox/SearchBox";
import GroupDetailsCard from "../../Components/GroupDetailsCard/GroupDetailsCard";
import { Spinner } from "../../Components/Spinner/Spinner";
import Lightbox from "react-awesome-lightbox";

import style from "./GroupDetails.module.css";
import groupAvatar from "../../assets/Images/groupAvatar.svg";

import projectSettings from "../../assets/Js/projectSettings";
import { getPlainToken, getUserData } from "../../assets/Js/tokenHandler";
import { callAPI } from "../../assets/Js/backendCommunication";
import { immediateToast } from "izitoast-react";
import { closeModel } from "../../assets/Js/closeModel";
import deleteConfirmationPrompt from "../../assets/Js/deleteConfirmationPrompt";
import { getDateFormat1 } from "../../assets/Js/getDateFormat1";
import { chatGroupEnum } from "../../assets/Js/chatGroupEnum";

const selectedGroupMemberActions = {
  delete: "delete",
};

const groupTypeEnum = {
  OneToOne: 1,
  GymGroup: 2,
  TrackGroup: 3,
  CustomGroup: 4,
};

const exitTypes = {
  leftItself: "left",
  removedByAdmin: "removed",
};

export default function GroupDetails({
  groupId,
  groupDetailsModalId,
  resetModalInfo,
  setRemoveUserWithThisId,
  resetMessageScreen,
  goToPrevScreen,
  goToNextScreen,
}) {
  const [AllMembersOfGroup, setAllMembersOfGroup] = useState([]);
  const [FilteredMembersOfGroup, setFilteredMembersOfGroup] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [GroupInfo, setGroupInfo] = useState({});
  const [bannerImage, setBannerImage] = useState(groupAvatar);
  const [selectedGroupMember, setSelectedGroupMember] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const [isCustomGroup, setIsCustomGroup] = useState(false);
  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);
  const userData = getUserData();

  useEffect(() => {
    if (groupId) {
      getGroupDetails();
    }
  }, [groupId]);

  useEffect(() => {
    if (selectedGroupMember.id && selectedGroupMember.action) {
      switch (selectedGroupMember.action) {
        case selectedGroupMemberActions.delete:
          removeFromGroupHandler();
          break;
        default:
          break;
      }
    }
  }, [selectedGroupMember.id]);

  const getGroupDetails = async () => {
    let url = `${projectSettings.baseUrl}/chats/groupDetails/${groupId}`;
    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let data = null;
    let response = "";

    if (response === "") {
      setIsLoading(true);
    }

    response = await callAPI(url, header, type, data, token);

    if (response) {
      let { data } = response;

      setIsLoading(false);

      if (data.StatusCode === 200) {
        let {
          CreatedAt,
          CreatedBy,
          Description,
          GroupId,
          GroupImage,
          GroupMembers,
          GroupName,
          GroupType,
        } = data.Result;

        setFilteredMembersOfGroup(GroupMembers);
        setAllMembersOfGroup(GroupMembers);
        setBannerImage(
          GroupImage
            ? projectSettings.baseImageUrl + "=" + GroupImage
            : groupAvatar
        );

        if (GroupType === chatGroupEnum.CustomGroup) {
          setIsCustomGroup(true);
        } else {
          setIsCustomGroup(false);
        }

        CreatedAt = getDateFormat1(CreatedAt);

        setGroupInfo({
          CreatedAt,
          CreatedBy,
          Description,
          GroupId,
          GroupImage,
          GroupName,
          GroupType,
        });

        let _isAdmin = GroupMembers?.filter(
          (user) => user.Id === userData.Id
        ).map((u) => u.IsAdmin);

        _isAdmin && setIsAdmin(_isAdmin[0]);
      } else {
        if (data?.Errors?.length) {
          immediateToast("warning", { message: data.Errors[0] });
        }
      }
    }
  };

  const removeFromGroupHandler = () => {
    deleteConfirmationPrompt(exitGroup, [
      groupId,
      selectedGroupMember.id,
      exitTypes.removedByAdmin,
    ]);
  };

  const leaveGroupHandler = () => {
    if (groupId && userData?.Id) {
      deleteConfirmationPrompt(exitGroup, [
        groupId,
        userData.Id,
        exitTypes.leftItself,
      ]);
    }
  };

  const deleteGroupHandler = () => {
    deleteConfirmationPrompt(deleteGroup);
  };

  const exitGroup = async (groupId, userId, reasonForFunctionCall) => {
    let url = `${projectSettings.baseUrl}/chats/removeuser/${groupId}/${userId}`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;
    let response = "";

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      let { data } = response;

      if (response) {
        setSelectedGroupMember({});

        if (response.data.StatusCode === 200) {
          removeUser(userId);
          if (reasonForFunctionCall === exitTypes.leftItself) {
            setRemoveUserWithThisId(groupId);
            resetMessageScreen();
          }

          if (isAdmin) {
            immediateToast("success", {
              message: "Athlete Removed Successfully",
            });
          } else {
            immediateToast("success", {
              message: "Existed Group Successfully",
            });
            resetModalInfo();
            closeModel(groupDetailsModalId);
          }
        } else {
          immediateToast("warning", { message: data.Errors[0] });
        }
      }
    }
  };

  const deleteGroup = async () => {
    let url = `${projectSettings.baseUrl}/chats/customGroup/delete/${groupId}`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;
    let response = "";

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      let { data } = response;

      if (response) {
        if (response.data.StatusCode === 200) {
          setRemoveUserWithThisId(groupId);
          resetMessageScreen();

          immediateToast("success", {
            message: "Group Deleted Successfully",
          });
          resetModalInfo();
          closeModel(groupDetailsModalId);
        }
      } else {
        immediateToast("warning", { message: data.Errors[0] });
      }
    }
  };

  const removeUser = (id) => {
    let _allMembersOfGroup = AllMembersOfGroup.filter(
      (eachUser) => eachUser.Id !== id
    );

    setAllMembersOfGroup(_allMembersOfGroup);
    setFilteredMembersOfGroup(_allMembersOfGroup);
  };

  const handlerFilterdData = (filteredData) => {
    setFilteredMembersOfGroup(filteredData);
  };

  const selectGroupMember = (
    id,
    isAdmin,
    role,
    userName,
    image,
    gender,
    weight,
    action
  ) => {
    setSelectedGroupMember({
      id,
      isAdmin,
      role,
      userName,
      image,
      gender,
      weight,
      action,
    });
  };

  const localGoToNextScreen = () => {
    goToNextScreen({ GroupInfo, AllMembersOfGroup });
  };

  const toggleImageViewer = () => {
    setIsImageViewerOpen(!isImageViewerOpen);
  };

  return (
    <div className={style.container}>
      <div className={`${style.banner}`} onClick={toggleImageViewer}>
        <img className={`${style.bannerImage}`} src={bannerImage} />
        <div className="overlay"></div>
        <div>
          {isImageViewerOpen && (
            <Lightbox
              image={bannerImage}
              title="Group Profile"
              onClose={toggleImageViewer}
            />
          )}
        </div>
        <div className={`${style.bannerInfo} w-100`}>
          <div className="d-flex justify-content-between align-items-center pl-4 pr-4">
            <div className={`${style.bannerText}`}>
              <div className="h4">{GroupInfo.GroupName}</div>
              <p>
                {GroupInfo.CreatedBy &&
                  GroupInfo.CreatedAt &&
                  `Created by ${GroupInfo.CreatedBy}, ${GroupInfo.CreatedAt}`}
              </p>
            </div>
            {isCustomGroup && isAdmin && (
              <div className={style.bannerIcon} onClick={localGoToNextScreen}>
                <i className="mdi mdi-table-edit h3 pointerCursor"></i>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={`${style.body} p-3`}>
        <SearchBox
          data={AllMembersOfGroup}
          propertyToLookFor={"UserName"}
          changeHandler={handlerFilterdData}
          searchBoxStyles={`${style.searchBox} mb-2 pl-2 pr-2`}
        />

        <div className="pl-2 colorMedium">
          {FilteredMembersOfGroup?.length} Participant
          {FilteredMembersOfGroup?.length > 1 ? "s" : ""}
        </div>

        <div
          className={`overflow-auto primaryScrollBar tertiaryScrollBar ${style.groupDetialsCardsContainer}`}
        >
          {IsLoading ? (
            <div>
              <Spinner />
            </div>
          ) : FilteredMembersOfGroup?.length ? (
            FilteredMembersOfGroup.map((eachMember) => (
              <GroupDetailsCard
                id={eachMember.Id}
                isAdmin={eachMember.IsAdmin}
                role={eachMember.Role}
                userName={eachMember.UserName}
                image={eachMember.Image}
                gender={eachMember.Gender}
                weight={eachMember.Weight}
                isAdminLoggedIn={isAdmin}
                selectGroupMember={selectGroupMember}
                selectedGroupMemberActions={selectedGroupMemberActions}
                isCustomGroup={isCustomGroup}
              />
            ))
          ) : (
            <p className="text-center">No Group Members Found</p>
          )}
        </div>
      </div>

      {isCustomGroup && (
        <div className={`${style.footer} pl-4 mt-2`}>
          {isAdmin ? (
            <div
              className="groupDetailsHoverEffect pointerCursor dangerColor"
              onClick={deleteGroupHandler}
            >
              <span>
                <i className={`mdi mdi-delete mr-2 ${style.iconSize}`}></i>
                Delete Group
              </span>
            </div>
          ) : (
            <div
              className="pointerCursor dangerColor"
              onClick={leaveGroupHandler}
            >
              <span>
                <i className={`mdi mdi-logout mr-2 ${style.iconSize}`}></i>
                Exit Group
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

GroupDetails.propTypes = {
  groupId: PropTypes.string,
  groupDetailsModalId: PropTypes.string,
  setRemoveUserWithThisId: PropTypes.func,
  resetMessageScreen: PropTypes.func,
  goToPrevScreen: PropTypes.func,
  goToNextScreen: PropTypes.func,
};
